import React, { useState } from 'react';
import PropTypes from 'prop-types';
import FeedbackModalStructure from './components/FeedbackModalStructure';
import FeedbackModalForm from './components/FeedbackModalForm';
import FeedbackModalThanks from './components/FeedbackModalThanks';
import { StyledFeedback } from './Feedback.styles';

const Feedback = ({ toggleHamburger }) => {
  const [step, setStep] = useState('step_1');

  const handleStep = (_step = 'step_1') => {
    setStep(_step);
  };

  const components = {
    step_1: (
      <FeedbackModalStructure
        handleStep={handleStep}
        toggleHamburger={toggleHamburger}
      />
    ),
    step_2: (
      <FeedbackModalForm
        handleStep={handleStep}
        toggleHamburger={toggleHamburger}
      />
    ),
    step_3: (
      <FeedbackModalThanks
        handleStep={handleStep}
        toggleHamburger={toggleHamburger}
      />
    ),
  };

  return (
    <StyledFeedback>
      <div className='feedback-component'>{components[step]}</div>
    </StyledFeedback>
  );
};

Feedback.propTypes = {
  toggleHamburger: PropTypes.func,
};

export default Feedback;
